<template>
  <div class="ub-fl">
    <h1 class="title">
      {{ $t('crm_deliver_stock_device_num.cksbsl') }}
    </h1>
    <div class="box">
      <div class="search-hd">
        <el-select
          v-model="productCodes"
          :multiple="true"
          collapse-tags
          style="width: 230px; float: left;"
          @change="onPageChange({ page: 1 })"
        >
          <el-option
            v-for="(item,index) in selData"
            :key="index"
            :label="item.productCode"
            :value="item.productCode"
          ></el-option>
        </el-select>
        <el-input
          v-model="formSearch.search"
          clearable
          style="float:right; width: 180px;"
          @input="onPageChange({ page: 1 })"
          :placeholder="$t('crm_deliver_stock_device_num.ji_shen_hao')"
        ></el-input>
      </div>
      <div>
        <custom-table
          v-model="deviceIn"
          tableCode="stock_device_num"
          :data="deviceList"
          height="500px"
          type="checkbox"
          ref="tb1"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
  </div>
</template>

<script>
/** 库存设备数量表 */

import apis from '@/utils/apis';

export default {
  props: {
    copy2ProductSn: {
      type: [String, Number],
      default: 'QY7V6M',
    },
    needDevices: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    needDevices: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },
  data() {
    return {
      tableCode: 'product_import_device',
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        search: '',
        orderId: '',
      },
      totalRows: 0,
      deviceIn: [],
      deviceList: [],
      componentNameChangeHandler: null,
      selData: [],
      productCodes: [],
    };
  },
  methods: {
    initSelData() {
      const record = [];
      const ret = [];
      this.needDevices.forEach((item) => {
        if (!record.includes(item.productCode)) {
          ret.push(item);
          record.push(item.productCode);
        }
      });
      this.selData = ret;
    },
    init() {
      this.initSelData();
      if (this.selData.length) {
        const firstItem = this.selData[0];
        this.productCodes = [firstItem.productCode];
        this.formSearch.orderId = firstItem.orderId;
        this.getDeviceList();
      }
    },
    getDeviceList() {
      if (this.productCodes.length) {
        this.$getJSON(apis.transferOrderPreDeliverList, {
          ...this.formSearch,
          productCodes: this.productCodes.join(','),
        }).then((res) => {
          this.deviceList = res.data.list;
          this.totalRows = res.data.total;
          return this.deviceList;
        });
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    getDeviceIn() {
      return this.deviceIn;
    },
    clearSelection() {
      this.$refs.tb1.$refs.tb1.clearSelection();
    },
  },
  mounted() {
    this.componentNameChangeHandler = this.$debounce(() => {
      this.onPageChange({ page: 1 });
    }, 300);

    this.getTableColumn();
    // this.getDeviceList();
  },
};
</script>

<style></style>
